import { Command } from './Command';
import { groupObjects, ungroupObject } from '../components/Editor/utils/groupUtils';

/**
 * GroupObjectsCommand - Groups multiple canvas objects into a fabric.Group.
 *
 * execute(): Creates the group, removes individual objects from canvas.
 * undo():    Dissolves the group, restores individual objects.
 *
 * @example
 * const objects = [...activeSelection.getObjects()];
 * canvas.discardActiveObject();
 * const cmd = new GroupObjectsCommand(canvas, objects);
 * commandStack.execute(cmd);
 */
export class GroupObjectsCommand extends Command {
  /**
   * @param {fabric.Canvas} canvas
   * @param {fabric.Object[]} objects - At least 2 objects to group
   */
  constructor(canvas, objects) {
    super();
    this.canvas = canvas;
    this.objects = objects;
    this.group = null;
  }

  execute() {
    const result = groupObjects(this.canvas, this.objects);
    if (result) {
      this.group = result.group;
    }
  }

  undo() {
    if (this.group) {
      ungroupObject(this.canvas, this.group);
    }
  }

  getDescription() {
    return `Gruppieren (${this.objects.length} Objekte)`;
  }
}
